module.exports = new __parcel__URL__("gif5.d935d903.webm").toString();